import React from 'react';

interface MenuPopupContextType {
    closeMenu: () => void;
}
export default React.createContext<MenuPopupContextType>({ closeMenu: () => {} });
